import { useScrollReveal } from './_hooks';

const DemoNumbers: React.FC = () => {
  const [quoteRef, quoteVisible] = useScrollReveal(0.3);

  return (
    <section className="relative bg-[#fdfcfa] py-24 sm:py-32">
      {/* Hairline rules */}
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-[#0a1024]/[0.08]" />
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-px bg-[#0a1024]/[0.08]" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <figure
          ref={quoteRef}
          className="mx-auto max-w-4xl text-center transition-all duration-1000"
          style={{
            opacity: quoteVisible ? 1 : 0,
            transform: quoteVisible ? 'translateY(0)' : 'translateY(28px)',
          }}>
          <div
            className="text-[80px] leading-none text-[#c08838]/40 sm:text-[120px]"
            style={{ fontFamily: 'Fraunces, serif', fontWeight: 400 }}>
            &ldquo;
          </div>
          <blockquote
            className="mt-[-32px] text-[28px] leading-[1.25] tracking-tight text-[#0a1024] sm:text-[36px] lg:text-[44px]"
            style={{ fontFamily: 'Fraunces, serif', fontWeight: 400 }}>
            We expected a demo.{' '}
            <span
              style={{
                fontStyle: 'italic',
                fontWeight: 500,
                fontVariationSettings: '"SOFT" 100, "opsz" 144',
                color: '#004790',
              }}>
              We left with a working agent
            </span>{' '}
            on our policy library — answering questions our team had been asking each other in Slack
            for years.
          </blockquote>
          <figcaption className="mt-10 flex flex-col items-center gap-1.5">
            <div className="flex items-center gap-3">
              <span className="inline-block h-px w-6 bg-[#0a1024]/30" />
              <span className="text-[11px] font-semibold uppercase tracking-[0.22em] text-slate-500">
                A typical business perspective
              </span>
              <span className="inline-block h-px w-6 bg-[#0a1024]/30" />
            </div>
            <span className="text-[13px] text-slate-400">
              Illustrative response — not a customer testimonial
            </span>
          </figcaption>
        </figure>
      </div>
    </section>
  );
};

export default DemoNumbers;
